if (!customElements.get('diana-header-search')) {
  customElements.define('diana-header-search', class DianaHeaderSearch extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.dialog = this.querySelector('[role="dialog"]');
      this.input = this.querySelector('input[name="q"]');
      this.closeButton = this.querySelector('[data-diana-search-close]');

      if (!this.details || !this.trigger || !this.dialog || !this.input || !this.closeButton) return;

      this.onToggle = () => {
        document.body.classList.toggle('diana-search-open', this.details.open);
        if (this.details.open) {
          this.input.focus();
        }
      };
      this.onClose = () => this.close(true);
      this.onKeydown = (event) => {
        if (!this.details.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close(true);
          return;
        }
        if (event.key === 'Tab') this.keepFocusInDialog(event);
      };

      this.details.addEventListener('toggle', this.onToggle);
      this.closeButton.addEventListener('click', this.onClose);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      this.closeButton?.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('diana-search-open');
    }

    close(restoreFocus = false) {
      if (!this.details?.open) return;
      this.details.open = false;
      document.body.classList.remove('diana-search-open');
      if (restoreFocus) this.trigger.focus();
    }

    keepFocusInDialog(event) {
      const controls = [...this.dialog.querySelectorAll(
        'button:not([disabled]), input:not([type="hidden"]):not([disabled])'
      )];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
}
